import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Clipboard = function Clipboard(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M42 46H6V6H16V8H8V44H40V8H32V6H42V46Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M31 11H17C15.9 11 15 10.1 15 9V5C15 3.9 15.9 3 17 3H31C32.1 3 33 3.9 33 5V9C33 10.1 32.1 11 31 11ZM17 5V9H31V5H17Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 27H12V29H36V27Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 21H12V23H36V21Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M31 15H17V17H31V15Z",
      fill: secondaryColor
    })]
  });
};
export default Clipboard;